/**
 * Фасад каталога шаблонов (GET /api/v1/admin/card-template-catalog).
 * Использование опционально — список ОИ по-прежнему доступен через card-api.service.
 */

import { get } from "@/lib/api-client-v2";

export interface CardTemplateCatalogListItem {
  module: "oi" | "rd" | "go" | "udgspz" | "visualizer" | "tactical";
  id: number;
  code: string;
  name: string;
  description?: string | null;
  status: string;
  version: number;
  is_active: boolean;
  is_default: boolean;
  object_kls_id?: number | null;
  /** Только module=rd — тип заявки KLS */
  request_type_kls_id?: number | null;
  /** module=go */
  entity_type_kls_id?: number | null;
  /** module=udgspz */
  eudg_type_kls_id?: number | null;
  /** module=visualizer — KLS условного знака */
  symbol_kls_id?: number | null;
  /** module=tactical — kind фичи или null (универсальный) */
  feature_kind?: string | null;
  organization_kls_id?: number | null;
  updated_at?: string | null;
  published_at?: string | null;
  created_by?: string | null;
  created_at?: string | null;
  archived_at?: string | null;
}

export interface CardTemplateCatalogListResponse {
  items: CardTemplateCatalogListItem[];
  total: number;
  skip: number;
  limit: number;
  module: string;
  module_ready: boolean;
  message?: string | null;
}

export async function fetchCardTemplateCatalog(params: {
  module: "oi" | "rd" | "go" | "udgspz" | "visualizer" | "tactical";
  status?: string;
  object_kls_id?: number;
  request_type_kls_id?: number;
  global_only?: boolean;
  is_active?: boolean;
  skip?: number;
  limit?: number;
}): Promise<CardTemplateCatalogListResponse> {
  const query: Record<string, string | number | boolean> = {
    module: params.module,
    skip: params.skip ?? 0,
    limit: params.limit ?? 50,
  };
  if (params.status !== undefined) query.status = params.status;
  if (params.object_kls_id !== undefined) query.object_kls_id = params.object_kls_id;
  if (params.request_type_kls_id !== undefined)
    query.request_type_kls_id = params.request_type_kls_id;
  if (params.global_only !== undefined) query.global_only = params.global_only;
  if (params.is_active !== undefined) query.is_active = params.is_active;

  return get<CardTemplateCatalogListResponse>("/admin/card-template-catalog", query);
}
